import styled from "styled-components"; 


export const ContainerResultados = styled.div`

 width: 100vw;
  height: 100vh;
  background-color: transparent;
  .redirection {
    position: absolute;
    height: max-content;
    width: max-content;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding-bottom: 20px;
  }
  .logo-dim {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -2;
  }
`;



export const HeaderHomeBar = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  margin: auto;
  color: var(--color-white);
  background-color: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);

  .title {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  .title-negrita {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }

  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .container-ellipse {
    width: 100%;
    height: max-content;
    /* background-color: red; */
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }

  ::after {
    content: "";
    position: absolute;
    width: 150%;
    height: 50px;
    bottom: -25px;
    z-index: -1;
    border-radius: 50%;
    background-color: var(--color-latex10);
  }
`;


export const BtnContainer = styled.div`
  width: 100%;
  margin: auto;
  margin-top: 100px;
  height: max-content;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 25px;
  svg {
    width: 25px;
    height: 25px;
  }
`;